<template>
    <v-dialog v-model="mostrar" persistent max-width="70vw" scrollable>
		<v-card max-height="600px">
			<v-toolbar flat :color="this.$store.state.title == 'Calendario' ? this.$store.state.corEvento : cor"></v-toolbar>
			<v-divider></v-divider>
            <v-card-text>
            <v-container>
                <v-row>
                    <v-col cols="12">
                        <h2 class="text-center">Você está excluindo o motivo "{{motivo.descricao}}"</h2>
                        <h3 class="text-center">Confirma a exclusão?</h3>
                    </v-col>
                </v-row>
            </v-container>
            </v-card-text>
            <v-card-actions>
				<v-spacer></v-spacer>
				<v-btn text color="primary" @click.stop="confirmar()">Confirmar</v-btn>
				<v-btn text color="primary" @click.stop="mostrar = false">Cancelar</v-btn>
			</v-card-actions>
		</v-card>
    </v-dialog>    
</template>

<script>
import Br from '@/config/barramento.js'
import metodos from '@/mixins/metodos'

// import { mapState } from 'vuex'
import { baseApiUrl, showError, showSuccess } from "@/config/global"
import axios from 'axios'


export default {
    name: 'motivo',
    mixins: [metodos],
    components:{
        
    },
    data(){
        return{
            cor: 'primary',
            mostrar: false,
            motivo: {},
        }
    },

    methods:{
        confirmar(){
            const url = `${baseApiUrl}/Cadastros/motivosAtendimento/delete.php`

                axios.post(url, {id: this.motivo.id})
                    .then(res => {
                        if(res.data.codigo == '01'){
                            showSuccess(res.data.mensagem)
                            Br.setMotivoExcluido(this.motivo)
                        }else{
                            showError(res.data.mensagem)
                        }
					})
					this.mostrar = false
			},
        },

    created(){
    
        Br.onExcluirMotivo(motivo => {
            
            this.motivo = motivo
            this.mostrar = true
        })
    },
}
</script>

<style scoped>

</style>